import type { ComputedRef, Ref } from 'vue'
import { twMerge } from 'tailwind-merge'
import { baseStyles } from '~/theme/base'
import type { BaseStyles, ComponentName } from '~/theme/base'
import { getThemeConfig } from '~/theme'

type StyleSlots<T> = { [K in keyof T]: () => string }

export function useVariants<K extends ComponentName>(
  component: K,
  opts?: { itemType?: 'dinner' | 'drinks' },
): { styles: ComputedRef<StyleSlots<BaseStyles[K]>>, theme: Ref<ThemeName> } {
  const theme = useTheme()

  const styles = computed(() => {
    const base = baseStyles[component] as Record<string, string>
    const config = getThemeConfig(theme.value)

    let overrides: Record<string, string> = {}
    if (component === 'menuItem') {
      overrides = (config.menuItem?.[opts?.itemType ?? 'dinner'] ?? {}) as Record<string, string>
    }
    else {
      overrides = ((config as Record<string, Record<string, string>>)[component] ?? {})
    }

    const resolved: Record<string, () => string> = {}
    for (const slot of Object.keys(base)) {
      const b = base[slot]!
      const o = overrides[slot] ?? ''
      resolved[slot] = () => twMerge(b, o)
    }
    return resolved as StyleSlots<BaseStyles[K]>
  })

  return { styles, theme }
}
